<mat-card appearance="outlined">
    <mat-card-header>
        <mat-card-title>
            {{ 'DmiSettings.Title' | translate }}
        </mat-card-title>
        <div class="widget-action-buttons" slHideIfDashboardEditMode>
            <sl-dmi-status-indicator #dmiStatusIndicator />
        </div>
    </mat-card-header>
    <mat-card-content>
        <form [formGroup]="formGroup" class="form-horizontal">
            <div class="pr-2">
                <mat-checkbox formControlName="dmiVote">{{ 'DmiSettings.Enabled' | translate }}</mat-checkbox>
                <sl-input type="text" placeholderKey="DmiSettings.ServerUrl" [control]="formGroup.controls['dmiServerUrl']" />
                <sl-input type="text" placeholderKey="User.User" [control]="formGroup.controls['dmiUsername']" />
                <sl-input type="text" placeholderKey="Login.Password" [control]="formGroup.controls['dmiPassword']" />
                <sl-input type="number" placeholderKey="DmiSettings.MeetingId" [control]="formGroup.controls['dmiMeetingId']" />
                <sl-input type="text" placeholderKey="DmiSettings.TvsSystemUrl" [control]="formGroup.controls['dmiTvsUrl']" />
            </div>
        </form>
    </mat-card-content>
    <mat-card-actions>
        @if (!isEditing()) {
            <button mat-button [disabled]="isMakingRequest() || !isDmiEnabled() || shouldDisableInitReset()" (click)="init()">
                <mat-icon>publish</mat-icon>
                {{ 'DmiSettings.Init' | translate }}
            </button>
            <button mat-button [disabled]="isMakingRequest() || !isDmiEnabled() || shouldDisableInitReset()" (click)="reset()">
                <mat-icon>refresh</mat-icon>
                {{ 'General.Reset' | translate }}
            </button>
            <button class="float-right" mat-button (click)="isEditing.set(true)">
                <mat-icon>edit</mat-icon>
                {{ 'General.Edit' | translate }}
            </button>
        } @else {
            <button mat-button (click)="cancel()">
                {{ 'General.Cancel' | translate }}
            </button>
            <button class="float-right" mat-button [disabled]="isMakingRequest()" (click)="save()">
                <mat-icon>save</mat-icon>
                {{ 'General.Save' | translate }}
            </button>
        }
    </mat-card-actions>
</mat-card>
